import React from "react";
import { DialogContainer } from "./DialogContainer";
import { withRouter } from "react-router-dom";

export const DialogContext = React.createContext();

export const useDialog = () => React.useContext(DialogContext);

function DialogProvider(props) {
  const [dialogs, setDialogs] = React.useState([]);
  const { children, history } = props;
  history.listen((location, action) => {
    // location is an object like window.location
    closeAllDialogs();
    console.log(action, location.pathname, location.state);
  });

  const createDialog = (option, disableBackdropClick = false) => {
    const dialog = { open: true, disableBackdropClick: disableBackdropClick, ...option };
    setDialogs((dialogs) => [...dialogs, dialog]);
  };

  const closeDialog = () => {
    setDialogs((dialogs) => {
      const latestDialog = dialogs.pop();
      if (!latestDialog) return dialogs;
      if (latestDialog.onClose) latestDialog.onClose();
      return [...dialogs];
    });
  };

  const closeAllDialogs = () => {
    dialogs.forEach((dialog) => {
      if (dialog.onClose) dialog.onClose();
    });
    setDialogs([]);
  };

  const contextValue = React.useRef([createDialog, closeDialog]);

  return (
    <DialogContext.Provider value={contextValue.current}>
      {children}
      {dialogs.map((dialog, i) => {
        return <DialogContainer key={i} {...dialog} onClose={closeDialog} />;
      })}
    </DialogContext.Provider>
  );
}

export default withRouter(DialogProvider);
